import {
  getComparedDateRanges
} from '@bingads-webui/date-ranges';
import { getStateComparisonDateRangeOption } from './comparison-date-range-option';
import { getSelectionDateParser } from './selection-date';

export default function getStateComparedDateRange({
  today,
  i18n,
  primaryRange,
  ComparisonDateRange,
}) {
  const parser = getSelectionDateParser(i18n);

  return ComparisonDateRange ? getComparedDateRanges({
    today,
    i18n,
    primaryRange,
    comparedCustomStart: parser(ComparisonDateRange.StartDate),
    comparedCustomEnd: parser(ComparisonDateRange.EndDate),
  })[getStateComparisonDateRangeOption(ComparisonDateRange.ComparisonDateRangeOption)] : null;
}
